import React from "react";

export const FilterSymbol = ({
    symbolType,
    color,
    icon,
}: {
    symbolType: "line" | "circle" | "triangle" | "square" | "other";
    color?: string;
    icon?: any;
}) => {
    switch (symbolType) {
        case "line": {
            return (
                <div className="flex items-center">
                    <div
                        className="w-4 h-[2px]"
                        style={{ backgroundColor: color }}
                    />
                </div>
            );
        }
        case "circle": {
            return (
                <div className="flex items-center">
                    <div
                        className="w-4 h-4 rounded-full"
                        style={{ backgroundColor: color }}
                    />
                </div>
            );
        }
        case "triangle": {
            return (
                <div className="flex items-center">
                    <div
                        className="w-0 h-0 border-l-[6px] border-l-transparent border-r-[6px] border-r-transparent border-b-[10px]"
                        style={{ borderBottomColor: color }}
                    />
                </div>
            );
        }
        case "square": {
            return (
                <div className="flex items-center">
                    <div
                        className="w-4 h-4 rounded-full"
                        style={{ backgroundColor: color }}
                    />
                </div>
            );
        }
        case "other": {
            return (
                <>
                    {icon && (
                        <div className="w-4 h-4">
                            {React.createElement(icon)}
                        </div>
                    )}
                </>
            );
        }
        default: {
            return (
                <div className="flex items-center">
                    <div
                        className="w-4 h-4 rounded-full"
                        style={{ backgroundColor: color }}
                    />
                </div>
            );
        }
    }
};
